import { render, staticRenderFns } from "./edior.vue?vue&type=template&id=c4d4c4de&scoped=true&"
import script from "./edior.vue?vue&type=script&lang=js&"
export * from "./edior.vue?vue&type=script&lang=js&"
import style0 from "./edior.vue?vue&type=style&index=0&id=c4d4c4de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d4c4de",
  null
  
)

export default component.exports